import type { ReactNode } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { buildAddressMapUrl } from "@/lib/utils/address-map-link";

interface AddressLinkProps {
  /** Plain-text version of the address, used to build the maps search query. */
  addressText: string | null | undefined;
  children: ReactNode;
  className?: string;
}

/**
 * Wraps address content in a link that opens the address in a maps app:
 * Google Maps on desktop, the OS map picker (geo:) on mobile.
 * Renders children unwrapped when there's no usable address text.
 */
export function AddressLink({ addressText, children, className }: AddressLinkProps) {
  const isMobile = useIsMobile();
  const url = buildAddressMapUrl(addressText ?? "", isMobile);

  if (!url) return <>{children}</>;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={
        className
          ? `text-primary no-underline hover:underline cursor-pointer ${className}`
          : "text-primary no-underline hover:underline cursor-pointer"
      }
    >
      {children}
    </a>
  );
}
